/**
 * Shows the desktop menu with optional animation.
 *
 * This function removes the animation-out class and adds the animation-in class to the menu element,
 * then sets the menu's display style to 'block'.
 *
 * @param {HTMLElement} el - The element that triggers the show action.
 * @param {HTMLElement} menu - The menu element to show.
 * @param {Object} params - Configuration parameters (not used in this function).
 * @param {Object} itemParams - Item-specific parameters.
 * @param {Object} itemParams.desktop - Desktop-specific parameters.
 * @param {string} itemParams.desktop.animationIn - The class for the animation-in effect.
 * @param {string} itemParams.desktop.animationOut - The class for the animation-out effect.
 * @returns {void}
 */
export default function desktopShow(el, menu, params, itemParams) {
  if (!menu) {
    console.error('Menu element is not defined');
    return;
  }

  const { animationIn, animationOut } = itemParams.desktop;

  menu.classList.remove(animationOut);
  menu.style.display = 'block';
  menu.classList.add(animationIn);
}
